import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { List } from 'immutable';
import {jsxActions as activeCassetesPageActions} from '../../actions/ActiveCassettesPage/activeCassetesPageActions';
import {jsxActions as headerActions} from '../../actions/Header/headerActions';
import {gridsNames} from '../../enums/gridsNames';
import { jsxActions as fetchEntitiesActions }      from '../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as activeCassettesGridActions } from '../../actions/ActiveCassettesPage/activeCassettesGridActions';
import { jsxActions as editAssetAttributesActions }  from '../../actions/Dialogs/EditAssetAttributesDialog/editAssetAttributesDialogActions';
import { jsxActions as moveAssetsActions }  from '../../actions/Dialogs/MoveAssetsDialog/moveAssetsDialogActions';
import { jsxActions as shelfLifeUpdateActions } from '../../actions/Dialogs/ShelfLifeUpdateDialog/shelfLifeUpdateDialogActions';
import { jsxActions as archiveAssetsActions }   from '../../actions/Dialogs/ArchiveAssetsDialog/archiveAssetsDialogActions';
import {jsxActions as exportActions} from '../../actions/Export/exportActions';
import {jsxActions as printRfidTagsActions} from '../../actions/Dialogs/PrintRfidTagsDialog/printRfidTagsDialogActions';
import { jsxActions as printPdfLabelsActions }      from '../../actions/Dialogs/PrintPdfLabelsDialog/printPdfLabelsDialogActions.js';
import { jsxActions as importAttributesUpdateWizardActions} from '../../actions/Wizards/ImportAttributesUpdateWizard/importAttributesUpdateWizardActions.js';
import { jsxActions as assignRemoveAssetsTagsActions} from '../../actions/Dialogs/AssignRemoveAssetsTagsDialog/assignRemoveAssetsTagsDialogActions.js';
import ActiveCassettesPage from '../../components/PredefinedList/ActiveCassettesPage/activeCassettesPage';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(activeCassetesPageActions, dispatch),
      header: bindActionCreators(headerActions, dispatch),
      fetchEntitiesActions:    bindActionCreators(fetchEntitiesActions, dispatch),
      activeCassettesGridActions: bindActionCreators(activeCassettesGridActions, dispatch),
      editAssetAttributesActions:      bindActionCreators(editAssetAttributesActions, dispatch),
      moveAssetsActions:      bindActionCreators(moveAssetsActions, dispatch),
      shelfLifeUpdateActions:   bindActionCreators(shelfLifeUpdateActions, dispatch),
      archiveAssetsActions:     bindActionCreators(archiveAssetsActions, dispatch),
      exportActions:      bindActionCreators(exportActions, dispatch),
      printRfidTagsActions: bindActionCreators(printRfidTagsActions, dispatch),
      printPdfLabelsActions: bindActionCreators(printPdfLabelsActions, dispatch),
      importAttributesUpdateWizardActions: bindActionCreators(importAttributesUpdateWizardActions, dispatch),
      assignRemoveAssetsTagsActions: bindActionCreators(assignRemoveAssetsTagsActions, dispatch),
    }
  }
}

let ActiveCassettesPageContainer = connect(
  (state) => {
    let grid = state.grid.get(gridsNames.PREDEFINED_LIST_ACTIVE_CASSETTES) ? state.grid.get(gridsNames.PREDEFINED_LIST_ACTIVE_CASSETTES) : null;
    return {
      sGrid:  grid,
      sHasRows: grid && grid.get('rows') ? grid.get('rows').size > 0 : false,
      sSelectedRowsData: grid ? grid.get('selectedRowsData') : List(),
      sEditAssetAttributesData: state.dialogs.get('editAssetAttributesDialog'),
      sMoveAssetsData:  state.dialogs.get('moveAssetsDialog'),
      sShelfLifeUpdateData: state.dialogs.get('shelfLifeUpdateDialog'),
      sArchiveAssetsData:   state.dialogs.get('archiveAssetsDialog'),
      sLoggedInUser : state.login.get('loggedInUser'),
      sPrintRfidTagsDialogData:    state.dialogs.get('printRfidTagsDialog'),
      sPrintPdfLabelsData: state.dialogs.get('printPdfLabelsDialog'),
      sImportAttributesUpdateWizardData: state.wizards.get('importAttributesUpdateWizard'),

    };
  },
  mapDispatchToProps
)(ActiveCassettesPage);


export default ActiveCassettesPageContainer;



